import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { v4 as uuidV4 } from 'uuid';

const apiClient: AxiosInstance = axios.create({});

apiClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const newConfig = { ...config };

    newConfig.headers = { ...config.headers };

    newConfig.headers['X-Request-ID'] = uuidV4();
    return newConfig;
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export default apiClient;
